"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Box = require("./Box.styles");
var _SX_PROP_CONFIG = require("./SX_PROP_CONFIG");
var Box = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_Box.StyledBox, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.Box = Box;
Box.displayName = 'Box';
Box.propTypes = {
  children: _propTypes.default.node,
  sx: _propTypes.default.shape(Object.assign({}, (0, _SX_PROP_CONFIG.getSxPropTypes)()))
};